<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="mainCon">
      <el-form
        label-width="160px"
        :model="form"
        :rules="rules"
        :show-message="isCurrentPlan ? true : false"
        :inline="true"
        ref="form"
      >
        <div>
          <el-form-item label="考试批次">
            <el-select v-model="planId">
              <el-option
                v-for="item in planData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 
          集中机房  1 
          双机位 2
         -->

        <el-form-item :label="showFlag ? '模考名称': '试考名称'" prop="name">
          <el-input v-model="form.name" :disabled="!isCurrentPlan" />
        </el-form-item>

        <!-- v-if="showFlag" -->
        <div>
          <el-form-item prop="beginTime" :label="showFlag ? '模考起止时间': '试考起止时间'">
            <el-date-picker
              :disabled="!isCurrentPlan || !showFlag"
              :value-format="dataFormat"
              v-model="form.beginTime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            至
          </el-form-item>
          <el-form-item label="" prop="endTime">
            <el-date-picker
              :default-time="defaultTime"
              :disabled="!isCurrentPlan || !showFlag"
              :value-format="dataFormat"
              v-model="form.endTime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </div>

        <div>
          <el-form-item label="课程选择" prop="courseId">
            <el-select
              v-model="form.courseId"
              placeholder="请选择"
              :disabled="!isCurrentPlan"
            >
              <el-option
                v-for="item in courseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="ml30">
            <span
              :class="form.courseId ? 'col_blue cp' : 'col_grayQ'"
              @click="addPaperDialog"
            >
              <i class="el-icon-plus mr5"></i
              >{{ showCourseList.length ? "修改试卷" : "添加试卷" }}
            </span>
          </el-form-item>
          <ots-table
            v-show="showCourseList.length"
            class="w80p ml160 mb30"
            :tableHeader="courseTableHeader"
            :tableData="showCourseList"
          ></ots-table>
        </div>

        <div>
          <el-form-item label="设置答卷时长" prop="examTime">
            <el-input
              class="short"
              placeholder="请输入"
              v-model.number="form.examTime"
              :disabled="!isCurrentPlan || !showFlag"
            >
              <template slot="suffix">分钟</template>
            </el-input>
          </el-form-item>
        </div>

        <div v-if="showFlag">
          <el-form-item label="考试（作答）次数" prop="answerTime">
            <el-input
              class="short"
              placeholder="请输入"
              v-model.number="form.answerTime"
              :disabled="!isCurrentPlan"
            ></el-input>
          </el-form-item>
        </div>

        <div v-if="showFlag">
          <el-form-item label="模考学生范围" v-if="planInfo.needAudit == 1 || planInfo.needAudit == 2 || needPayment == 1">
            <!-- v-if="planInfo.needAudit == 1" -->
            <div class="df pt3" >
              <span class="mr20">审核情况</span>
              <el-form-item label="" prop="needAudit">
                <el-checkbox-group v-model="form.needAudit" :disabled="true">
                  <!-- <el-checkbox :label="0">未审核</el-checkbox> -->
                  <el-checkbox :label="2">{{planInfo.needAudit == 1 ? "审核通过": "终审通过"}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <!-- <div class="df pt3" v-if="planInfo.needAudit == 2">
              <span class="mr20">审核情况</span>
              <el-form-item label="" prop="needAudit">
                <el-checkbox-group v-model="form.needAudit" :disabled="!isCurrentPlan">
                  <el-checkbox :label="0">待初审</el-checkbox>
                  <el-checkbox :label="1">初审通过</el-checkbox>
                  <el-checkbox :label="2">终审通过</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div> -->

            <div
              class="df"
              :class="isNeedAudit ? 'mt10' : ''"
              v-if="needPayment == 1"
            >
              <span class="mr20">缴费情况</span>
              <el-form-item label="" prop="needPay">
                <el-checkbox-group
                  v-model="form.needPay"
                  :disabled="!isCurrentPlan"
                >
                  <el-checkbox :label="0">未缴费</el-checkbox>
                  <el-checkbox :label="1">已缴费</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- 添加试卷弹窗 -->
    <ots-custom-dialog :dialog.sync="paperDialog" title="添加试卷" width="60%">
      <template v-slot:content>
        <div v-if="dialogLoading" style="color: red;">正在查询中，等稍后... <i class="el-icon-loading"></i></div>
        <div>
          <ots-table-group
            :tableHeader="paperTableHeader"
            :tableOption="paperTableOption"
            :tableData="paperTableData"
            :pagination="paperPagination"
            @handleCurrentChange="handleCurrentChange"
            @changeNum="paperChangeSize"
            @changePage="paperChangePage"
          ></ots-table-group>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="paperDialog = false">取消</el-button>
        <el-button round type="primary" @click="dealCoursePaper"
          >确定</el-button
        >
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  getSinglePlan,
  getPagePlan,
  getCurrentPlanFn,
} from "@/http/modules/examSet/examBatch";
import { getMockSet, setMockExam } from "@/http/modules/applySet/mockExam.js";
import { getPaperFn } from "@/http/modules/examSet/section";
import { getSelectCourse } from "@/http/modules/baseSet/course";
export default {
  name: "mockExam",
  data() {
    return {
      defaultTime: "23:59:59",

      needPayment: "",
      paperDialog: false,
      dataFormat: "yyyy-MM-dd HH:mm:ss",
      saveMethods: "addOrEdit",
      backMethods: "goIndex",
      planData: [],
      planId: "",
      form: {
        name: "",
        endTime: "",
        beginTime: "",
        needAudit: [2],
        needPay: [0],
        courseId: "",
        paperName: "",
        paperId: "",
        examTime: "",
        answerTime: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写模考名称", trigger: "blur" },
          { min: 1, max: 50, message: "最多可输入30个字", trigger: "blur" },
        ],
        beginTime: [
          { required: true, message: "请选择模考开始时间", trigger: "change" },
        ],
        endTime: [
          { required: true, message: "请选择模考截止时间", trigger: "change" },
        ],
        examTime: [
          {
            required: true,
            type: "number",
            message: "答题时长必须为数字值",
            trigger: "blur",
          },
        ],
        answerTime: [
          {
            required: true,
            type: "number",
            message: "考试次数必须为数字",
            trigger: "blur",
          },
        ],
        needAudit: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个审核状态",
            trigger: "change",
          },
        ],
        needPay: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个缴费状态",
            trigger: "change",
          },
        ],
        courseId: [{ required: true, message: "请选择课程并添加试卷" }],
      },
      mockInfo: {},
      planInfo: {
        // courseList: [],
        needAudit: "",
      },
      courseList: [],
      paperTableOption: {
        singleSelect: true,
      },
      paperTableData: [],
      paperTableHeader: [
        {
          title: "试卷名称",
          prop: "name",
        },
        {
          title: "难度",
          prop: "difficultyDegree",
        },
        {
          title: "创建日期",
          prop: "createTime",
        },
        {
          title: "专业",
          prop: "courseName",
        },
        {
          title: "使用次数",
          prop: "usedCount",
        },
        {
          title: "总分",
          prop: "score",
        },
      ],
      paperPagination: {
        total: 0,
      },
      paperListParams: {
        courseId: "",
        planId: "",
        page: 1,
        size: 10,
      },
      courseTableHeader: [
        {
          title: "课程名称",
          prop: "courseName",
        },
        {
          title: "试卷名称",
          prop: "paperName",
        },
        {
          title: "操作",
          type: "button",
          click: this.deletePaper,
          formatter: () => "删除",
        },
      ],
      currentPlanId: "",
      initFlag: false,
      selectCourseName: "",
      selectCourseId: "",
      publish: null,
      scorePublish: null,
      showFlag: true,
      dialogLoading : false,
    };
  },
  computed: {
    courseName() {
      let name = "";
      let temp = this.courseList.filter(
        (item) => item.id == this.form.courseId
      );
      if (temp.length) {
        name = temp[0].name;
      }
      return name;
    },
    showCourseList() {
      if (this.form.paperName && this.selectCourseName) {
        return [
          {
            courseName: this.selectCourseName,
            paperName: this.form.paperName,
            courseId: this.selectCourseId,
          },
        ];
      } else {
        return [];
      }
    },
    isCurrentPlan() {
      // return this.scorePublish == 0 && this.publish == 1;
      // return this.scorePublish == 1
      let plan = this.planData.filter((item) => item.id == this.planId);
      if (plan.length) {
        if (plan[0].planState == "6") {
          return false;
        }
      }
      return true;
    },
    isNeedAudit() {
      return this.planInfo.needAudit == 1 || this.planInfo.needAudit == 2;
    },
  },
  watch: {
    planId(val) {
      this.getCurrentPlan();
      // 获取模考设置
      getMockSet({ planId: val }).then(({ data }) => {
        if (data) {
          this.mockInfo = data;
          for (let item in this.form) {
            this.form[item] = data[item];
          }






          // 设置学生范围的两个状态
          // if (data.needAudit == 0) {
          //   this.form.needAudit = [0];
          // } else if (data.needAudit == 1) {
          //   this.form.needAudit = [1];
          // } else if (data.needAudit == 2) {
          //   this.form.needAudit = [2];
          // } else if (data.needAudit == 3) {
          //   this.form.needAudit = [0, 1];
          // } else if (data.needAudit == 4) {
          //   this.form.needAudit = [0, 2];
          // } else if (data.needAudit == 5) {
          //   this.form.needAudit = [1, 2];
          // } else if (data.needAudit == 6) {
          //   this.form.needAudit = [0, 1, 2];
          // }
          this.form.needAudit = [2];
          this.form.paperId = data.paperId
          this.form.needPay = data.needPay == 2 ? [0, 1] : new Array(1).fill(data.needPay);
          this.initFlag = true;
        } else {
          this.form = {
            name: "",
            endTime: "",
            beginTime: "",
            needAudit: [2],
            needPay: [0],
            courseId: "",
            paperName: "",
            examTime: "",
            answerTime: "",
          };
          this.form.planId = val;
        }
      });
      getSinglePlan({ planId: val }).then(({ data }) => {
        this.publish = data.publish;
        this.scorePublish = data.scorePublish;
        this.needPayment = data.isPay;
        for (let item in this.planInfo) {
          this.planInfo[item] = data[item];
        }
        // 2024年7月30日
        this.form.beginTime = this.form.beginTime ? this.form.beginTime: data.endAudit ? data.endAudit: data.endSign;
        this.form.endTime = this.form.endTime ? this.form.endTime: data.endExam;
        this.form.examTime = this.form.examTime ? this.form.examTime: 30;
      });
    },
    courseName(val) {
      if (this.initFlag) {
        this.selectCourseName = val;
        this.selectCourseId = this.form.courseId;
        this.initFlag = false;
      } else {
        this.showCourseList = [];
        this.selectCourseName = "";
        this.selectCourseId = "";
        this.form.paperName = "";
        this.form.paperId = "";
      }
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    initData() {
      getPagePlan({ publish: 1}).then((data) => {
        this.planData = data.data;
        this.planId = data.data[0].id;
      });
      // this.mixin_getCurrentPlanInfo().then((data) => {
      //   this.needPayment = data.isPay;
      //   this.planId = data.id;
      //   this.currentPlanId = data.id;
      // });
      getSelectCourse().then(({ data }) => {
        this.courseList = data;
      });
    },
    getCurrentPlan() {
      getCurrentPlanFn({ planId: this.planId }).then(({data}) => {
        this.needPayment = data.isPay;
        this.currentPlanId = data.id;
        this.showFlag = data.examTypeId == 2 ? true: false;
      });
    },
    addPaperDialog() {
      if (this.form.courseId) {
        this.paperDialog = true;
        this.getPaper();
      } else {
        this.$message.warning("请先选择课程");
      }
    },
    paperChangeSize(num) {
      this.paperListParams.size = num;
      this.getPaper();
    },
    paperChangePage(p) {
      this.paperListParams.page = p;
      this.getPaper();
    },
    async getPaper() {
      this.dialogLoading = true;
      this.paperListParams.courseId = this.form.courseId;
      this.paperListParams.planId = this.planId;
      const { data } = await getPaperFn(this.paperListParams);
      if(data){
        this.paperTableData = data.papers;
        this.paperPagination.total = data.total;
      }
      this.dialogLoading = false;
    },
    dealCoursePaper() {
      this.paperDialog = false;
      this.form.paperName = this.selectPaperName;
      this.form.paperId = this.selectPaperId;
      // fixed 选择课程 -> 试卷列表更改问题
      this.selectCourseName = this.courseName;
      this.selectCourseId = this.form.courseId;
    },
    handleCurrentChange(row) {
      const { id, name } = row;
      this.selectPaperName = name;
      this.selectPaperId = id;
    },
    deletePaper() {
      this.form.paperId = "";
      this.form.paperName = "";
    },
    goIndex() {
      window.location.reload();
    },
    addOrEdit() {
      // if (!this.isCurrentPlan) {
      //   this.$message.error("历史批次不可修改模考信息！");
      //   return;
      // }
      // let currentPlan = this.planData.filter(item => item.id == this.planId)
      // if (currentPlan[0].planState == '6') {
      //   this.$message.error("历史批次不可修改模考信息！");
      // }
      if (!this.isCurrentPlan) {
        this.$message.error("成绩已发不可修改模考信息");
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (!this.showCourseList.length) {
            this.$message.warning("请添加试卷！");
            return;
          }
          let { needAudit, needPay, ...params } = this.form;
          let mockParams = {
            ...params,
          };

          // 1. 判断是否是人工审核
          if (this.isNeedAudit) {
            // 2. 判断是否是一级人工审核
            if (needAudit.length == 3) {
              mockParams.needAudit = 6;
            } else if (needAudit.length == 1) {
              mockParams.needAudit = needAudit[0];
            } else if (needAudit.length == 2) {
              let sum = needAudit[0] + needAudit[1];
              if (sum == 1) {
                mockParams.needAudit = 3;
              } else if (sum == 2) {
                mockParams.needAudit = 4;
              } else if (sum == 3) {
                mockParams.needAudit = 5;
              }
            }
          }

          // 2024年6月19日
          // mockParams.needPay = needPay.length > 1 ? 2 : needPay.join();
          mockParams.needPay = 2;
          mockParams.courseId = this.showCourseList[0].courseId;
          mockParams.planId = this.planId;
          setMockExam(mockParams).then(({ code }) => {
            if (code == 1) {
              this.$message.success("设置成功");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-checkbox-group {
  height: 30px;
}
</style>
